var React = require('react');

function SmallClose (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"CloseSmall"},React.createElement("g",{"id":"Vector"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.45952 1.95958C2.85004 1.56906 3.48321 1.56906 3.87373 1.95958L14.5404 12.6262C14.9309 13.0168 14.9309 13.6499 14.5404 14.0405C14.1499 14.431 13.5167 14.431 13.1262 14.0405L2.45952 3.37379C2.06899 2.98327 2.06899 2.3501 2.45952 1.95958Z","fill":"#E8EFFF","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M14.5404 1.95958C14.1499 1.56906 13.5167 1.56906 13.1262 1.95958L2.45952 12.6262C2.069 13.0168 2.069 13.6499 2.45952 14.0405C2.85004 14.431 3.48321 14.431 3.87373 14.0405L14.5404 3.37379C14.9309 2.98327 14.9309 2.3501 14.5404 1.95958Z","fill":"#E8EFFF","key":1})])));
}

SmallClose.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = SmallClose;

SmallClose.default = SmallClose;
